exports.unescapeAsciiCharacters = (str) => {
    return str.replace(/&#(\d+);/g, (m, n) => {
                return String.fromCharCode(n);
            });
}